import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JsonConvert } from 'json2typescript';
import { DataService } from '../data.service';
import { DocumentCategory, PropertyOwnerType, PropertyType } from '../models/declarations';
import { PropertyCardModel } from '../models/propertyCardModel';
import { OwnersdocumentsComponent } from '../ownersdocuments/ownersdocuments.component';

@Component({
  selector: 'app-loading-progress',
  templateUrl: './loading-progress.component.html',
  styleUrls: ['./loading-progress.component.scss']
})
export class LoadingProgressComponent implements OnInit {

  constructor(private data: DataService, private router: Router) { }

  ngOnInit(): void {
    this.LoadDocumentCategories();
  }

  LoadPropertyCard() : boolean {
    this.data.request<PropertyCardModel>("kiosk/property/" + this.data.SelectedCardNumber,null,"GET").subscribe((v) => {
      console.log(v);
      this.sortPropertyDocs(v);
      return true;
    });
    return false;
  }

  LoadDocumentCategories() : boolean{
    this.data.request<Array<DocumentCategory>>("documentcategories",null,"GET").subscribe((v) => {
      this.data.DocumentCategories = v;
      console.log(v);
      this.LoadPropertyOwnerTypes();
      return true;
    });
    return false;
  }


  LoadPropertyOwnerTypes() : boolean {
    this.data.request<Array<PropertyOwnerType>>("ownertypes",null,"GET").subscribe((v) => {
      this.data.PropertyOwnerTypes = v;
      console.log(v);
      this.LoadPropertyTypes();
      return true;
    });
    return false;
  }

  LoadPropertyTypes() : boolean {
    this.data.request<Array<PropertyType>>("propertytypes",null,"GET").subscribe((v) => {
      this.data.PropertyTypes = v;
      console.log(v);
      this.LoadPropertyCard();      
      return true;
    });
    return false;
  }

  sortPropertyDocs(v: PropertyCardModel): void {
    v.propertydocuments.forEach(e => {
      e.cat = this.data.DocumentCategories.find( x => x.DocumentCategoryCode == e.category);
    });

    v.owners?.forEach(owner => {
      owner.taxreturns = owner.taxreturns.sort((a,b) => a.returnyear < b.returnyear ? 1 : -1);
      owner.annualreturns = owner.annualreturns.sort((a,b) => a.year < b.year ? 1 : -1);
    });

    v.propertydocuments = v.propertydocuments.sort((a,b) => a.documentdate < b.documentdate ? 1 : -1);
    this.data.SelectedProperty = v;
    //Find out selected card bearer
    this.data.SelectedCardBearer =  this.data.SelectedProperty.cardbearers.find(x => x.bid == this.data.SelectedCardBearerID)

    this.router.navigate(['dashboard'],{skipLocationChange:false});
  }

}
